import { css } from "@emotion/react";
import { ImgHTMLAttributes } from "react";

export type AspectRatios = "1/1" | "2/1" | "16/9" | "3/2" | "4/3" | "none";

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt: string;
    aspectRatio?: AspectRatios;
}

const imageCSS = (ratio?: string) => css`
    max-width: 100%;
    ${ratio && ratio !== "none"
        ? `
    aspect-ratio: ${ratio};
    object-fit: cover;
    width: 100%;
  `
        : ""}
`;

export const Image = ({ src, alt, aspectRatio, ...rest }: ImageProps) => {
    return <img src={src} alt={alt} css={imageCSS(aspectRatio)} {...rest} />;
};
